export default "__VITE_ASSET__7Eq_$OKV__"